import React, { useState } from 'react';
import './GetAQuoteInjury.css';
import FormsHeading from './FormsHeading';
import QuoteResultModal from './QuoteResultModal';
import { submitFormPayload } from '../utils/formSubmission';
import { buildPaPremiumPayload } from '../utils/premiumPayloads';

function GetAQuoteInjury() {
    const [submitState, setSubmitState] = useState({ loading: false, message: '' });
    const [quoteResult, setQuoteResult] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formElement = event.currentTarget;
        setSubmitState({ loading: true, message: '' });

        try {
            const formValues = Object.fromEntries(new FormData(formElement).entries());
            const payload = buildPaPremiumPayload(formValues);
            const result = await submitFormPayload('/api/premium/personalaccident', payload);

            if (result.skipped) {
                setSubmitState({ loading: false, message: '' });
                return;
            }

            setQuoteResult(result.data || result.raw || null);
            setSubmitState({ loading: false, message: '' });
            formElement.reset();
        } catch (error) {
            setSubmitState({ loading: false, message: '' });
            setQuoteResult({ error: error.message || 'Submission failed. Please try again.' });
        }
    };

  return (
        <div className='GetAQuoteInjury'>
            <div>
            <FormsHeading text='Personal  Details' />
            </div>
            <div className='GetAQuoteInjury_Forms'> 
                <form onSubmit={handleSubmit}> 
                    <div className='GetAQuoteInjury_TopQuery'>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Fullname: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" name="fullName" placeholder="Please enter your fullname" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Phone: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="tel" name="phone" placeholder="Enter your contact here" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Email Address: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="email" name="email" placeholder="Enter your email number" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Nature of Work: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select Nature of Work" required name="natureOfWork" list="exampleList2"/>
                                <datalist id="exampleList2" style={{backgroundColor: 'green'}}>
                                    <option value="Clerical" />  
                                    <option value="Non Clerical" />
                                </datalist>
                        </div>
                    </div>
                    <FormsHeading text='Policy  Details' />
                    <div className='GetAQuoteInjury_MiddleQuery'>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Start Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="startDate" placeholder="Enter Departure Date" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">End Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="endDate" placeholder="Enter Return Date" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Sum Insured: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="sumInsured" placeholder="Enter Insurance Amount" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Medical Expense Benefit Rate (%): <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="medicalExpenseBenefitRate" placeholder="e.g. 1.5" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Currency: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select Currency" required name="currency" list="exampleList"/>
                                <datalist id="exampleList" style={{backgroundColor: 'green'}}>
                                    <option value="GMD" />  
                                    <option value="USD" />
                                    <option value="GHC" /> 
                                    <option value="GBP" /> 
                                </datalist>
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Salary Frequency: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Monthly" required name="salaryFrequency" list="salaryFrequencyList"/>
                            <datalist id="salaryFrequencyList" style={{backgroundColor: 'green'}}>
                                <option value="Monthly" />
                                <option value="Weekly" />
                                <option value="Quarterly" />
                            </datalist>
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Monthly Income: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="monthlyIncome" placeholder="Enter monthly income" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Multiplier: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="multiplier" placeholder="Enter multiplier" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Permanent Disability Benefit: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="permanentDisabilityBenefit" placeholder="Enter benefit amount" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Permanent Disability Rate (%): <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="permanentDisabilityBenefitRate" placeholder="e.g. 2.0" required />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Temporary Disability Benefit:</label><br/>
                            <input type="number" min="0" step="0.01" name="temporalDisabilityBenefit" placeholder="Enter benefit amount" />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Temporary Disability Rate (%):</label><br/>
                            <input type="number" min="0" step="0.01" name="temporalDisabilityBenefitRate" placeholder="e.g. 1.0" />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Capital Benefit:</label><br/>
                            <input type="number" min="0" step="0.01" name="capitalBenefit" placeholder="Enter capital benefit" />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Number of Weeks:</label><br/>
                            <input type="number" min="0" step="1" name="numberOfWeeks" placeholder="e.g. 52" />
                        </div>
                        <div className='GetAQuoteInjury_InputBox_Query'>
                            <label for="fname">Weekly Benefit:</label><br/>
                            <input type="number" min="0" step="0.01" name="weeklyBenefit" placeholder="Enter weekly benefit" />
                        </div>
                    </div>
                    <div className="submitAction" >
                        <input className='FormSubmit' type="submit" value={submitState.loading ? 'SUBMITTING...' : 'SUBMIT'} disabled={submitState.loading} />
                    </div>
                    <QuoteResultModal data={quoteResult} onClose={() => setQuoteResult(null)} />
                </form>
            </div>
        </div>
    )
}

export default GetAQuoteInjury;
